// extracted by mini-css-extract-plugin
module.exports = {"kidsAccountNavWrapper":"Bk","hidden":"Bl","menuBackground":"Bm","avatar":"Bn","header":"Bo","accountNavAvatar":"Bp","buttonPlaceholder":"Bq","accountLinks":"Br","accountLink":"Bs"};